<template>

    <div class="profile-info" v-if="userInfo">
        <div class="profile-info-img">
           <img v-if="userInfo && userInfo.photo" :src="require(`@/assets/images/users/${userInfo.photo}`)" :alt="userInfo.photo" />
        </div><!-- /. profile-info-img -->

        <div class="profile-desc">

            <div class="profile-desc-top">
                <div class="profile-desc-top-left">

                    <div class="mobile-profile-toggle">
                        <h2>{{ userInfo.name }}</h2>
                        <div class="profile-toggle-mbl">
                            <button class="btn badge-btn" v-if="userInfo.activebadges">
                                <img :src="require(`@/assets/icon/${userInfo.activebadges[0].name}`)" :alt="userInfo.activebadges[0].name" />
                            </button> 
                            <button class="btn badge-btn" v-if="isToggleBadges" @click="isToggleBadges=!isToggleBadges">
                                <img :src="require(`@/assets/icon/${`toggle-up.png`}`)" />
                            </button>
                            <button class="btn badge-btn" v-else  @click="isToggleBadges=!isToggleBadges">
                                <img :src="require(`@/assets/icon/${`toggle-down.png`}`)" />
                            </button>
                        </div>
                    </div>

                    <!-- If Has any active badge -->
                    <div class="profile-btn-wrap" v-if="isToggleBadges">
                        <div  v-if="userInfo.activebadges && userInfo.activebadges.length!=0">
                            <button class="btn badge-btn" v-for="(data, index) in userInfo.activebadges" :key="index">
                                <img :src="require(`@/assets/icon/${data.name}`)" :alt="data.name" />
                            </button>                            
                            <button class="btn profile-btn" @click="badgeModal">
                                See more badges
                            </button>
                        </div>
                        <div v-else>                        
                            <button class="btn profile-btn no-badge">
                                No badge
                            </button>
                        </div>
                    </div>

                </div><!-- /. profile-desc-top-left -->
            </div><!-- /. profile-desc -->

            <h4>@{{ userInfo.username }}</h4>

            <div class="profile-desc-top-right">

                <!-- For Authenticate User -->
                <div class="profile-btn-wrap" v-if="authUser">                           
                    <button class="btn profile-btn" @click="updateModal">
                       <img src="../../assets/icon/edit.svg" alt="edit"> Edit Profile
                    </button>
                </div>

                <!-- For Other User -->
                <div class="profile-btn-wrap" v-else>     
                    <button class="btn messanger" @click="sendMessage">
                       <img src="../../assets/icon/messanger.svg" alt="messanger">
                    </button>

                    <div v-if="isFollow" class="isFollowing">                      
                        <button class="btn profile-btn" @click="isFollow=!isFollow">
                           <img src="../../assets/icon/check-icon.svg" alt="edit"> Following
                        </button>
                    </div>  
                    <div v-else>                    
                        <button class="btn profile-btn" @click="isFollow=!isFollow">
                           <img src="../../assets/icon/plus-icon.svg" alt="edit"> Follow
                        </button>
                    </div>

                    <div class="profile-opt">
                        <block-unblock :icon="`sort-down.svg`"></block-unblock>
                    </div>
                </div>
            </div>

            <p>{{ userInfo.description }}</p>

        </div><!-- /. profile-info-img -->

    </div>

</template>



<script>    
import { EventBus } from '../../main';

export default {
    props: ['userInfo','authUser'],
    name: "profile-info",

    data() {
        return {
            isFollow:false,
            chatOpen:false,
            isToggleBadges:true,
        }
    },

    methods: {
        updateModal(){
             EventBus.$emit('updateInfo',true);
        },

        badgeModal() {
            EventBus.$emit('badgemodal',true);
        },

        sendMessage(){
            let data = {
                id:1,
                name:'Ricardo Lopez',
                desc:'Three Ways To Get Travel Disco...',
                time: '11:23 am',
                img: 'chat-user1.png',
                messages:[
                    {
                      body: 'Become A Travel Pro In One Easy',
                      id:2,
                      date: 'Tuesday, February 25, 2020 2:00 AM'
                    },
                    {
                      body: 'Lorem ipsum dolor sit amet',
                      id:1,
                      date: 'Tuesday, February 25, 2020 2:05 AM'
                    },
                    {
                      body: 'Lorem ipsum dolor sit amet',
                      id:2,
                      date: 'Tuesday, February 25, 2020 2:10 AM'
                    },
                    {
                      body: 'Lorem ipsum dolor sit ametLorem ipsum dolor sit amet',
                      id:2,
                      date: 'Tuesday, February 25, 2020 2:10 AM'
                    },
                ]
            }
            EventBus.$emit('message', data);
         
        }
    }
}

</script>
